import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "datatables.net-bs5"
import "datatables.net-responsive-bs5"

export default class extends Controller {
  static targets = ["userFilter", "nameFilter", "tokenFilter", "statusFilter"]

  connect() {
    const tableEl = $("#devices-table")

    this.dataTable = tableEl.DataTable({
      responsive: true,
      pageLength: 10,
      order: [[3, "desc"]],
      dom:
        "<'row mb-3'<'col-sm-4'l><'col-sm-4'><'col-sm-4'f>>" +
        "<'row'<'col-12'tr>>" +
        "<'row mt-3'<'col-sm-5'i><'col-sm-7'p>>",
      language: { searchPlaceholder: "Search devices...", search: "" }
    })

    // Custom filtering
    $.fn.dataTable.ext.search.push((settings, data) => {
      if (settings.nTable !== tableEl[0]) return true

      const user = data[0].toLowerCase()
      const name = data[1].toLowerCase()
      const token = data[2].toLowerCase()
      const status = data[4].trim()

      const fUser = this.userFilterTarget.value.toLowerCase()
      const fName = this.nameFilterTarget.value.toLowerCase()
      const fToken = this.tokenFilterTarget.value.toLowerCase()
      const fStatus = this.statusFilterTarget.value

      if (fUser && !user.includes(fUser)) return false
      if (fName && !name.includes(fName)) return false
      if (fToken && !token.includes(fToken)) return false
      if (fStatus && status !== fStatus) return false

      return true
    })

    // Bind events
    this.userFilterTarget.addEventListener("keyup", () => this.refresh())
    this.nameFilterTarget.addEventListener("keyup", () => this.refresh())
    this.tokenFilterTarget.addEventListener("keyup", () => this.refresh())
    this.statusFilterTarget.addEventListener("change", () => this.refresh())
  }

  refresh() {
    this.dataTable.draw()
  }

  clearFilters() {
    this.userFilterTarget.value = ""
    this.nameFilterTarget.value = ""
    this.tokenFilterTarget.value = ""
    this.statusFilterTarget.value = ""

    this.dataTable.search("")
    this.dataTable.draw()
  }
}
